export const hasEventDescriptionContent = (value?: string | null): boolean => {
  if (!value) return false;

  const normalized = value.replace(/<[^>]*>/g, '').trim();
  return normalized.length > 0;
};

export const sanitizeEventDescription = (value?: string | null): string => {
  if (!value) return '';

  return value.trim();
};
